import React from 'react'

export default function UserFilterRow(props) {
  return (
    <div className="filter-row">
      <span>{ props.label }</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={ props.isChecked }
          onChange={ props.onChange } />
        <span className="slider round"></span>
      </label>
    </div>
  )
}
